var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewPictureFeedback(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 4.44444V35.5556C40 38 38 40 35.5556 40H4.44444C2 40 0 38 0 35.5556V4.44444C0 2 2 0 4.44444 0H35.5556C38 0 40 2 40 4.44444ZM17.7777 30.0221L13.111 24.3999C12.6444 23.8443 11.7999 23.8666 11.3777 24.4443L5.84437 31.5554C5.2666 32.2888 5.77771 33.3554 6.71104 33.3554H33.3555C34.2666 33.3554 34.7999 32.311 34.2444 31.5777L26.4444 21.1777C25.9999 20.5777 25.111 20.5777 24.6666 21.1554L17.7777 30.0221Z",
    fill: "#555893"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewPictureFeedback);
export default __webpack_public_path__ + "static/media/new_picture_feedback.eda571be.svg";
export { ForwardRef as ReactComponent };